export default function Products() {
  const products = [
    {
      name: 'Jaggery',
      description: 'Chemical free jaggery sourced directly from trusted farms, processed using traditional methods to retain its rich nutrients and authentic taste. Available in both solid blocks and fine powder, our jaggery is ideal for food processing, confectionery, beverages, and retail markets. Free from chemicals and additives, it offers a healthier alternative to refined sugar with consistent quality for bulk export.',
      image: 'https://public.readdy.ai/ai/img_res/9f6cdb68997acdeb18c8d2753d839759.jpg',
    },
    {
      name: 'Textiles',
      description: 'We supply high-quality textile products crafted with precision and durability, suitable for international wholesale and retail markets. Our range includes vibrant designs, superior fabric quality, and customizable options to meet global fashion and home furnishing demands. We ensure consistency, competitive pricing, and timely delivery.',
      image: 'https://readdy.ai/api/search-image?query=High%20quality%20Indian%20textile%20fabrics%20with%20vibrant%20colors%20and%20traditional%20patterns%2C%20cotton%20and%20silk%20materials%2C%20neatly%20folded%20and%20stacked%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20export%20quality%20textiles%2C%20commercial%20image&width=800&height=600&seq=prod2&orientation=landscape',
    },
    {
      name: 'Dried Mushrooms',
      description: 'Carefully processed and hygienically dried mushrooms to preserve flavor, aroma, and nutritional value. We offer a premium range including Oyster mushrooms, Milky mushrooms, and Button mushrooms, suitable for food industry applications, restaurants, and retail packaging. Our products meet export standards with long shelf life and superior quality.',
      image: 'https://readdy.ai/api/search-image?query=Premium%20dried%20mushrooms%20in%20wooden%20bowl%2C%20various%20types%20of%20dehydrated%20mushrooms%20including%20oyster%20milky%20and%20button%20varieties%2C%20natural%20brown%20colors%2C%20clean%20white%20background%2C%20professional%20food%20photography%20for%20export%2C%20high%20quality%20commercial%20product%20image&width=800&height=600&seq=prod3&orientation=landscape',
    },
    {
      name: 'Black Pepper',
      description: 'Premium-quality Indian black pepper known for its strong aroma, rich flavor, and high piperine content. We supply both whole black pepper and finely ground pepper powder, ideal for spices, seasoning, food processing, and retail markets. Sourced from the best farms, our pepper ensures consistent quality and global export standards.',
      image: 'https://readdy.ai/api/search-image?query=Premium%20black%20pepper%20corns%20in%20wooden%20bowl%20and%20scattered%20on%20white%20surface%2C%20fresh%20Indian%20spices%2C%20rich%20dark%20color%2C%20professional%20spice%20photography%20for%20export%20business%2C%20clean%20simple%20background%2C%20high%20quality%20commercial%20image&width=800&height=600&seq=prod4&orientation=landscape',
    },
    {
      name: 'Turmeric',
      description: 'High-grade turmeric sourced from trusted farms, known for its vibrant color, strong aroma, and high curcumin content. Available in both whole dried turmeric fingers and finely processed turmeric powder, suitable for culinary, medicinal, and industrial applications. Hygienically processed and export-ready with assured purity.',
      image: 'https://readdy.ai/api/search-image?query=Bright%20golden%20turmeric%20powder%20and%20fresh%20turmeric%20roots%20on%20white%20surface%2C%20vibrant%20yellow%20color%2C%20Indian%20spices%20for%20export%2C%20professional%20product%20photography%2C%20clean%20minimal%20background%2C%20high%20quality%20commercial%20image&width=800&height=600&seq=prod5&orientation=landscape',
    },
  ];

  return (
    <section id="products" className="py-12 lg:py-16 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Title */}
        <div className="text-center mb-10">
          <h2 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-4">
            Our Export Products
          </h2>
          <p className="text-lg lg:text-xl text-gray-600">
            Premium quality products sourced directly from India
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
          {products.map((product, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-6 bg-white">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {product.name}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {product.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}